<plyca-ui-collapsable-panel
  [config]="{
    toggleable: config().toggleable,
    collapseIcon: config().collapseIcon,
    expandIcon: config().expandIcon,
    header: config().header,
    iconHeader: config().iconHeader
  }"
>
  @if (config().isFormPlyca) {
    <div class="form-filter-panel">
      <formPlyca #formPlycaRef [config]="{ isSubscribeValueChange: true }" [formConfig]="formConfig" [manageWaitService]="false" (valuesFormChange)="onValueChange($event)" />
    </div>
  }
  <ng-content />
</plyca-ui-collapsable-panel>
